<template>
  <div>
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>招接待宾馆预约系统</el-breadcrumb-item>
        <el-breadcrumb-item>预定信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form :model="listParams">
        <el-row>
          <el-col style="width:190px;float:left;">
            <el-form-item label="审核状态：" prop="status">
              <el-select
                size="small"
                v-model="listParams.status"
                style="width:100px;float:left;"
                clearable
              >
                <el-option value="3" label="已通过"></el-option>
                <el-option value="2" label="已拒绝"></el-option>
                <el-option value="1" label="待审核"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col style="width:240px;float:left;">
            <el-form-item label="预留手机号：" prop="mobile">
              <el-input
                v-model="listParams.tel"
                size="small"
                placeholder="请输入预定手机号"
                style="width:140px;"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col style="width:57px;float:left;">
            <el-button
              size="small"
              type="primary"
              @click="searchData"
              style="margin-top:4px;"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result
      :page-info="pager"
      :loading="tableLoading"
      @page-current-change="handleCurrentChange"
      @page-size-change="handleSizeChange"
    >
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px;">
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column prop="" align="center" label="审核状态">
          <template slot-scope="scope">
            <span
              v-if="scope.row.statusValue == 3"
              style="color:rgba(0, 150, 136, 1)"
              >{{ scope.row.statusDisplay }}</span
            >
            <span
              v-if="scope.row.statusValue == 2"
              style="color:rgba(255, 152, 0, 1)"
              >{{ scope.row.statusDisplay }}</span
            >
            <span
              v-if="scope.row.statusValue == 1"
              style="color:rgba(16, 16, 16, 0.38)"
              >{{ scope.row.statusDisplay }}</span
            >
          </template>
        </el-table-column>

        <el-table-column prop="checkInTime" align="center" label="用户昵称">
        </el-table-column>

        <el-table-column prop="checkInTime" align="center" label="保障手机号">
        </el-table-column>

        <el-table-column prop="id" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="primary"
              @click="showCheck(scope.row.id)"
            >
              审 核
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>

    <el-dialog
      title="审核操作"
      :visible.sync="dialogFormVisible"
      style="text-align: center;"
    >
      <el-form style="width:200px;margin:auto" :model="form">
        <el-form-item>
          <el-select v-model="form.status" placeholder="请选择">
            <el-option label="通过" value="3"></el-option>
            <el-option label="拒绝" value="2"></el-option>
            <el-option label="待审核" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" style="margin:auto;margin-top:50px;">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="check">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {},
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0
      },
      dialogFormVisible: false,
      form: {},
      bodyParams: [],
      tempDate: "",
      orderId: 0
    };
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    showCheck(id) {
      this.dialogFormVisible = true;
      this.orderId = id;
    },
    check() {
      const bodyParams = Object.assign({}, this.listParams, {
        orderId: this.orderId,
        status: this.form.status
      });
      this.$http({
        url: global.apiUrl + "/reception/order/check",
        method: "POST",
        params: bodyParams
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.$message.success(res.body.info);
              this.dialogFormVisible = false;
              this.loadTableData();
            } else {
              this.tableData = [];
            }
          } else {

            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/reception/order/list/hotelAdmin",
        method: "GET",
        params: this.bodyParams
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data && res.body.data.orders.length > 0) {
              this.tableData = res.body.data.orders;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {

            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    searchData: function() {
      this.tableLoading = false;
      const checkInTime = this.tempDate[0];
      const checkOutTime = this.tempDate[1];
      const status = parseInt(this.listParams.status);
      this.bodyParams = Object.assign({}, this.listParams, {
        status: status,
        checkInTime: checkInTime,
        checkOutTime: checkOutTime,
        tel: this.listParams.tel,
        page: this.pager.pageIndex,
        size: this.pager.pageSize
      });
      this.loadTableData();
    },
    /**
     * 重置表单
     * @param name
     */
    resetForm(name) {
      this.$refs[name].resetFields();
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    }
  }
};
</script>
<style>
#convalescenceInfoTable {
  width: 100%;
}
#convalescenceInfoTable th {
  font-weight: normal;
  text-align: left;
  font-size: 14px;
}
#convalescenceInfoTable td {
  font-size: 14px;
}
</style>
